// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__6ED91","notes":"Notes_notes__3AVn8","note":"Notes_note__2Snlc","markdown":"Notes_markdown__1Wfkd"};